import React, { useState } from 'react';
import './ResourcesLayout.css';
const ResourcesLayout = ({ activeSection, setActiveSection, children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleOptionClick = (section) => {
    setActiveSection(section);
    setIsMobileMenuOpen(false); // Close menu after selection
  };

  return (
    <>
      {/* Hero Section */}
      <div className="hero-section">
        <img 
          src="/resource_lib.png" 
          alt="Resource Library" 
          className="hero-image"
        />
      </div>

      {/* Main Content Area with Sidebar */}
      <div className="resources-container">
        {/* Mobile Menu Button and Dropdown */}
        <div className="mobile-menu">
          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
          >
            <span className="menu-icon"></span>
            Resources
          </button>
          {isMobileMenuOpen && (
            <div className="mobile-dropdown">
              <div 
                className={`dropdown-option ${activeSection === 'toolkit' ? 'active' : ''}`}
                onClick={() => handleOptionClick('toolkit')}
              >
                Commonwealth Toolkits
              </div>
              <div 
                className={`dropdown-option ${activeSection === 'sas' ? 'active' : ''}`}
                onClick={() => handleOptionClick('sas')}
              >
                SAS Initiative Resources
              </div> 
            </div>
          )}
        </div>

        {/* Desktop Sidebar */}
        <div className="sidebar">
          <div 
            className={`sidebar-option ${activeSection === 'toolkit' ? 'active' : ''}`}
            onClick={() => setActiveSection('toolkit')}
          >
            Commonwealth Toolkits
          </div>
          <div 
            className={`sidebar-option ${activeSection === 'sas' ? 'active' : ''}`}
            onClick={() => setActiveSection('sas')}
          >
            SAS Initiative Resources
          </div>
        </div>

        <div className="main-content">
          <div className="content-area">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default ResourcesLayout;
